var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpPanelMSS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spPanel_m_s_s",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.002,
    height: 56.003,
    viewBox: "0 0 56.002 56.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Panel_Stop-Sel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_175",
    "data-name": "\\u6955\\u5186\\u5F62 175",
    transform: "translate(7.995 8)",
    fill: "#fff",
    stroke: "#5fc7bc",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.001,
    cy: 20.001,
    r: 20.001,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.001,
    cy: 20.001,
    r: 21.501,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_181",
    "data-name": "\\u6955\\u5186\\u5F62 181",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(11.995 12)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1497",
    "data-name": "\\u30D1\\u30B9 1497",
    d: "M0,0H56V56H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "panel",
    transform: "translate(10.998 10.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3006",
    "data-name": "\\u9577\\u65B9\\u5F62 3006",
    width: 34,
    height: 34,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2685",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2685",
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5777",
    "data-name": "\\u30D1\\u30B9 5777",
    d: "M0,2.759,10,0V20L0,17.241Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3009",
    "data-name": "\\u9577\\u65B9\\u5F62 3009",
    width: 1,
    height: 20,
    transform: "translate(11 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mute",
    transform: "translate(16.998 16.998)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_286",
    "data-name": "\\u7DDA 286",
    x2: 22,
    y2: 22,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_286-2",
    "data-name": "\\u7DDA 286",
    x2: 22,
    y2: 22,
    fill: "none",
    stroke: "#e8231e",
    strokeLinecap: "square",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpPanelMSS);
export default __webpack_public_path__ + "static/media/spPanel_m_s_s.37797b87fe9b9f55e6995219c18188ee.svg";
export { ForwardRef as ReactComponent };